var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"p-0 m-0",attrs:{"id":"map-tab","title":"Map Tab"}},[_c('Map',{ref:"map-ref"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }